import "./index.scss";
import cn from "classnames";

import RadioItem from "./RadioItem";

const RadioGroup = ({
  name,
  label,
  hint,
  error,
  onChange,
  options,
  value: initValue,
  readonly,
  helper_text,
}: any) => {
  return (
    <div className={cn("radio-group", { readonly })}>
      <div className="radio-group__container">
        {label && (
          <label className="radio-group__label typo-body">{label}</label>
        )}
        <div className="radio-group__content">
          {Object.entries(options).map(([key, value]: any) => {
            const helperText: string[] = helper_text?.[key];

            return (
              <RadioItem
                key={key}
                id={key}
                value={value}
                helperText={helperText}
                {...{ name }}
                {...(readonly
                  ? { checked: initValue === key }
                  : {
                      defaultChecked: initValue === key,
                      onChange: () => {
                        onChange(key);
                      },
                    })}
              />
            );
          })}

          {hint && <span className="radio-group__hint">{hint}</span>}
          {error && <span className="radio-group__error">{error}</span>}
        </div>
      </div>
    </div>
  );
};

export default RadioGroup;
